import { AxiosResponse } from 'axios';

import { IEdition } from 'src/interfaces/Edition';
import { IParticipant } from 'src/interfaces/Participant';

import { isSignupOpenForEdition } from './visibilityFilter';

export function getCreatedParticipantFromSaveResponse(
  response: AxiosResponse<IParticipant | IParticipant[]> | void,
): IParticipant | undefined {
  const data = response?.data;
  if (!data) {
    return undefined;
  }
  if (Array.isArray(data)) {
    return data.at(-1);
  }
  return data.id ? data : undefined;
}

export type OfferRegistrationAfterCreateOptions = {
  /**
   * When true (default), public signup must be open for the edition.
   * System Participants sets false for on-premise admin signup.
   */
  requireSignupOpen?: boolean;
};

export function shouldOfferRegistrationAfterParticipantCreate(
  id: string | undefined,
  editionId: string | undefined,
  editionsById: Record<string, IEdition> | undefined,
  options: OfferRegistrationAfterCreateOptions = {},
): boolean {
  const { requireSignupOpen = true } = options;
  if (id || !editionId) {
    return false;
  }
  if (!requireSignupOpen) {
    return true;
  }
  return isSignupOpenForEdition(editionsById?.[editionId]);
}
